import * as React from "react"
import { useEffect } from 'react'

import { Box } from '@mui/material'
import { CommonFilters } from '@components'
import { COMMON_FILTER_KEYS } from '@constants'
import { CUSTOM_DASHBOARD_ROUTES } from '@constants/routes'
import { useAppDefaultFilters } from '@hooks'
import {isLoadingCommonFilters, isSystemBusy} from '@signals'
import { isEmptyDynamicAssortment } from "./@signals";


export default function DynamicAssortmentFilters() {
    const { callUserDefaultFilters, userFilters, isLoadingDefaultFilters } = useAppDefaultFilters(CUSTOM_DASHBOARD_ROUTES.DYNAMIC_ASSORTMENT_ID, CUSTOM_DASHBOARD_ROUTES.ID)

    useEffect(() => {
        callUserDefaultFilters()
    }, [])

    return <Box data-tour="dynamic-assortment-filters">
    <CommonFilters
        components={{
            country: true, site: true,
            sku: true, favFilters: true,
            favFiltersOnlyLine: true, skuGroup: true
        }}
        compProps={{
            country: { grid: { md: 3, } },
            site: { grid: { md: 3 } },
            sku: { grid: { md: 3 } },
            skuGroup: { grid: { md: 3 } },
            favFiltersOnlyLine: { grid: { md: 9 } },
            favFilters: {
                grid: { md: 3 },
                allowedFilters: [
                    COMMON_FILTER_KEYS.COUNTRY, COMMON_FILTER_KEYS.RETAILER, COMMON_FILTER_KEYS.SKU_GROUP,
                    COMMON_FILTER_KEYS.SKU
                ],
                dashboardKey: CUSTOM_DASHBOARD_ROUTES.DYNAMIC_ASSORTMENT_ID
            }
        }}
        onSubmit={() => {
            isSystemBusy.value = false
            isLoadingCommonFilters.value = true
            isEmptyDynamicAssortment.value = false
        }}
        defaultValues={userFilters}
        isLoadingDefaultFilters={isLoadingDefaultFilters}
    />
    </Box>
}
